import React from 'react';

const Input = ({type,name,value,placeholder,required,onChange}) => {

  return (
    <div className='my-5'>
        <input 
            className='h-[45px] px-4 bg-custom-charcoal border border-custom-light-grey rounded-md w-full' 
            type={type ? type : 'text'} 
            name={name || ''} 
            value={value || ''} 
            placeholder={placeholder || ''} 
            required={required ? true : false}
            onChange={onChange || null}
        />
    </div>
  );
};

export default Input;
